import React from 'react';
const Next = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="20"
      viewBox="0 0 12 22"
    >
      <g>
        <g>
          <path
            fill="none"
            stroke="#e84249"
            strokeLinecap="round"
            strokeMiterlimit="20"
            d="M1 1v0l10 10v0L1 21v0"
          />
        </g>
      </g>
    </svg>
  );
};

export default Next;
